var angular = require('angular');
var _module = angular.module('listreports.listing', []);
var _ = require('lodash');
var babou = require('babou-js');
const Address = require('lana');
const BABOU_URL = {"apiKey":"cQ9FPlat9hTDppWRHIvPqx63t3KkEvVL","url":"https://babou.listreports.com/v1"}.url;
const BABOU_API_KEY = {"apiKey":"cQ9FPlat9hTDppWRHIvPqx63t3KkEvVL","url":"https://babou.listreports.com/v1"}.apiKey;
babou.setConfig({
    url: BABOU_URL,
    api_key: BABOU_API_KEY,
});

_module.factory('$listing', [
    '$http',
    '$log',

    function ($http, $log) {
        var NEST_URL = "https://nest.me";

        return {
            directMatch: null,
            get: function (listingAddress) {
                var _this = this;
                var parsedAddress = listingAddress.replace(' ', '+');
                return $http.get(NEST_URL + '/v1/search?limit=1&q=' + parsedAddress)
                    .then(function (res) {
                        var listing = null;
                        var directMatch = res.data.data.direct_match;
                        if (directMatch) {
                            _this.directMatch = directMatch;
                            window.directMatch = directMatch;

                            listing = _.pick(directMatch, ['id', 'open_houses', 'virtual_tours']);
                            listing.open_houses = listing.open_houses.filter(function (event) {
                                var eventDate = new Date(event.date_iso);
                                var currentDate = new Date();
                                return eventDate > currentDate;
                            });
                        }
                        return listing;
                    }).catch(function (err) {
                        console.log(err);
                    });
            },

            getCityStateZip: function (address) {
                const addressParts = new Address(address);
                return {
                    city: _.get(addressParts, 'city', null),
                    state: _.get(addressParts, 'state', null),
                    zip: _.get(addressParts, 'zip', null),
                };
            },

            getLocalHousingMarketStats: function (address) {
                const addressParts = this.getCityStateZip(address);
                const city = _.get(addressParts, 'city', null);
                const state = _.get(addressParts, 'state', null);
                const zip = _.get(addressParts, 'zip', null);
                const areas = (city && state)
                    ? [{
                        formatted_term: city + ', ' + state,
                        search_term: city + ', ' + state,
                        search_type: 'city',
                    }]
                    : [{
                        formatted_term: zip,
                        search_term: zip,
                        search_type: 'zipcode',
                    }];

                const options = {
                    cache: true,
                    include_listings: false,
                    include_listing_stats: true,
                    include_market_segments: false,
                    enhance_listings_with_preferred_vendor_ids: false,
                    include_open_houses: false,
                    useSourceZipBlacklist: true,
                    limit: 30,
                    skip: 0,
                    timeout: 10000,
                    include_new_listings: 0,
                    include_abn_buyers: 0,
                    initial_retry_delay: 500,
                    retries: 0,
                    search_filter_params: [
                        { name: 'stories', value: null },
                        { name: 'include_no_floors', value:true },
                        { name: 'hometype', value: ['Single house', 'Condo', 'Townhome'] },
                    ],
                };

                return babou.searchListings(areas, options)
                    .then(function (response) {
                        const stats = _.get(response, 'data.listing_stats') || {};
                        return stats;
                    })
                    .catch(function (err) {
                        $log.error(err);
                        return {};
                    });
            }

        };
    }
])
;

module.exports = _module;
